import './PagingPanel.less';
import React, {useEffect} from 'react';
import {translate} from "../../i18n";
import Icon from "../icon/Icon";

export default function PagingPanel({goTo, redirectFromNotExistPage, currentPage, totalItems = null, pageSize, pageSizeOptions, changePageSize}) {

    const isValid = totalItems !== null;
    const totalPages = totalItems !== null && totalItems > 0 ? Math.ceil(totalItems / pageSize) : 1;
    const itemsLocationBegin = currentPage * pageSize + 1;
    const itemsLocationEnd = Math.min(currentPage * pageSize + pageSize, totalItems);

    useEffect(() => {
        if (!redirectFromNotExistPage) {
            return;
        }

        if (currentPage < 0) {
            redirectFromNotExistPage(0);
        }

        if (!isValid) {
            return;
        }

        if (currentPage > totalPages - 1) {
            redirectFromNotExistPage(totalPages - 1);
        }
    }, [currentPage, totalPages, isValid]);

    return <div className='paging-panel'>
        <div className="left">
            {
                itemsLocationBegin <= itemsLocationEnd &&
                <div className="page-items-location">{translate('Showing ::begin - ::end of ::total', {
                    begin: itemsLocationBegin,
                    end: itemsLocationEnd,
                    total: totalItems
                })}</div>
            }
        </div>

        <div className="right">
            {
                pageSizeOptions &&
                <div className='page-size-setting'>
                    <span className='label'>{translate('Results per page')}</span>
                    <select
                        value={pageSize}
                        onChange={(event) => changePageSize(Number.parseInt(event.target.value))}>
                        {
                            pageSizeOptions.map(option =>
                                <option key={option} value={option}>
                                    {option}
                                </option>
                            )
                        }
                    </select>
                </div>
            }

            <div className='page-info'>{translate('Page ::current / ::total', {
                current: currentPage + 1,
                total: totalPages
            })}</div>

            <div className='button-nav'>
                <button type='button'
                        disabled={currentPage <= 0}
                        onClick={() => goTo(0)}
                >
                    <Icon name='angle-double-left'/>
                </button>
                <button type='button'
                        disabled={currentPage <= 0}
                        onClick={() => goTo(currentPage - 1)}
                >
                    <Icon name='angle-left'/>
                </button>
                <button type='button'
                        disabled={currentPage >= totalPages - 1}
                        onClick={() => goTo(currentPage + 1)}
                >
                    <Icon name='angle-right'/>
                </button>
                <button type='button'
                        disabled={currentPage >= totalPages - 1}
                        onClick={() => goTo(totalPages - 1)}
                >
                    <Icon name='angle-double-right'/>
                </button>
            </div>
        </div>
    </div>;
}
